import type { StackProps, TextProps } from '@chakra-ui/react';
import { Skeleton, Text, VStack } from '@chakra-ui/react';
import type { BigNumber } from '@ethersproject/bignumber';

import type { StakeInfoTokenProps } from '../StakaInfoToken';
import { StakeInfoToken } from '../StakaInfoToken';

interface VaultInfoRowProps extends StackProps {
  label: string;
  amount: BigNumber | undefined;
  labelProps?: TextProps;
  tokenProps?: StakeInfoTokenProps;
}

const VaultInfoRow = ({
  label,
  amount,
  labelProps,
  tokenProps,
  ...restProps
}: VaultInfoRowProps) => {
  return (
    <VStack alignItems="flex-start" gap={0} {...restProps}>
      <Text textStyle="md" color="#C377FF" fontWeight={700} {...labelProps}>
        {label}
      </Text>
      <Skeleton min-h="24px" min-w="80px" loading={!amount}>
        <StakeInfoToken value={amount} {...tokenProps} />
      </Skeleton>
    </VStack>
  );
};

export default VaultInfoRow;
